module.exports = "/wp-content/plugins/farmacy/assets/js/images/stepIndicatorOrderReceived-c20f9e99fd96793151095317ce59c25c.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/cart/order-complete/img/stepIndicatorOrderReceived.png
 ** module id = 563
 ** module chunks = 1 9 12 144
 **/